import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardBody, FormFeedback, Label, Input } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useHistory } from "react-router-dom";

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const CompanyManagement = props => {
  const [modal_Delete_Company, setmodal_Delete_Company] = useState(false);
  function Delete_Company(com_id) {
    setDeleteCompanyId(com_id);
    setmodal_Delete_Company(!modal_Delete_Company);
    // removeBodyCss();
  }

  const history = useHistory();
  React.useEffect(() => {
    if (localStorage.getItem('admin_type') !== 'admin') {
      history.replace('/dashboard');
    }
  }, [history]);
  
  //meta title
  document.title = "Company Management";
	const location = useLocation();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const [deleteCompanyId, setDeleteCompanyId] = useState(null);
  const handleDeleteCompany = async () => {
  try {
    const jsonpar = JSON.stringify({ com_id: deleteCompanyId });
    const res = await postRequest('delete-company', jsonpar); // or getRequest if your API uses GET

    if (res && res.code === 200) {
      setAlertData({
        variant: 'success',
        message: res.message,
      });
      setDeleteCompanyId(null); // reset the ID after deletion
      handleLoadGetCompany(); // refresh list
    } else {
      setAlertData({
        variant: 'error',
        message: res.message || 'Failed to delete company',
      });
    }
  } catch (error) {
    console.error("Delete Error:", error);
    setAlertData({
      variant: 'error',
      message: 'Something went wrong while deleting company',
    });
  }
  resetAlertData();
  setmodal_Delete_Company(false);
};


  const [StandardModal, setStandardModal] = React.useState(false);
  const togStandardModal = async (elementData) => {
    validation.setValues({
      ...validation.values,
          com_id: elementData.com_id,
      });
      setStandardModal(true);
  }
  // Open modal for changing status
  const [statusModal, setStatusModal] = useState(false);
  const [selectedCrewId, setSelectedCrewId] = useState(null);
  const [status, setStatus] = useState("");
  const openStatusModal = (crewm_id, status) => {
    setSelectedCrewId(crewm_id);
    if(status == "active"){
      setStatus("inactive");
    }else{
      setStatus("active");
    }
    setStatusModal(true);
  };

const handleChangeStatus = async () => {
  try {

    const jsonpar = JSON.stringify({ com_id: selectedCrewId , status: status});
    const res = await postRequest('update-company-status', jsonpar);

    if (res && res.code === 200) {
      setAlertData({
        variant: 'success',
        message: res.message || 'Status updated successfully',
      });

      // Refresh company list after updating status
      handleLoadGetCompany();
    } else {
      setAlertData({
        variant: 'error',
        message: res.message || 'Failed to update status',
      });
    }
  } catch (error) {
    console.error("Status Update Error:", error);
    setAlertData({
      variant: 'error',
      message: 'Something went wrong while updating status',
    });
  }

  resetAlertData();
  setStatusModal(false);
};


  const [CompanyData, setCompanyData] = React.useState([]);
  const [CompanyTBody, setCompanyTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.name}</td>
        <td>{element.code}</td>
        <td>
          <Button
            className="status-btn"
            color={element.status == "active" ? "success" : "danger"}
            onClick={() => openStatusModal(element.com_id, element.status)}
          >
            {element.status.toUpperCase()}
          </Button>
        </td>
        <td className="text-center">
          <div className="centerLink">
            <Link
              title="Edit Company"
              to={"/edit_company/" + btoa(element.com_id)}
              className="font-size-14 bg-primary edit-box"
            >
              <i className="bx bxs-edit"></i>
            </Link>
            <Link
              title="Delete Company"
              to="#"
              className="font-size-14 bg-primary edit-box"
              onClick={() => {
                Delete_Company(element.com_id)
              }}
            >
              <i className="bx bx-trash"></i>
            </Link>
          </div>
        </td>
      </tr>
    ))

    setCompanyTBody(tempTBody);
  }
  const handleLoadGetCompany = async () => {
    const res = await getRequest('get-company');
    if (res && res.code === 200) {
      let originalText = res.data;
      const filtered = originalText.filter(item => item.lang == localStorage.getItem("I18N_LANGUAGE"));

        setCompanyData(filtered);

        handleT1Body(filtered);
      

    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="9" className="text-center">No records found</td>
                      </tr>);

      setCompanyTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }


  React.useEffect(() => {
    handleLoadGetCompany();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Company Management")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="table-responsive mb-0">
                      <table className="table table-hover table-highlight" style={{ minWidth: '1000px' }}>
                        <thead>
                          <tr>
                            <th style={{ width: '400px' }}>Company Name</th>
                            <th style={{ width: '200px' }}>Company Code</th>
                             <th>Status</th>
                            <th className="text-center" >Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {CompanyTBody}
                        </tbody>
                      </table>
                    </div>
                    <div className="infoIcon">

                      <div className="infoIconBox">
                        <i className="bx bxs-edit"></i>
                        <p>Edit Company</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-trash"></i>
                        <p>Delete Company</p>
                      </div>

                     

                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>

      <Modal isOpen={modal_Delete_Company} toggle={() => { Delete_Company(); }} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Delete Company</h5>
            <button type="button" onClick={() => { setmodal_Delete_Company(false); }} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <p>Are you sure you wan't to delete this company?</p>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={handleDeleteCompany} >Delete</Button>
            <Button type="button" color="light" onClick={() => { setmodal_Delete_Company(false); }} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

      {/* Status Change Modal */}
     {/* Status Change Modal */}
<Modal
  isOpen={statusModal}
  toggle={() => setStatusModal(!statusModal)}
  centered  // 👈 This makes it open in the middle
>
  <ModalBody>
    <h5>Change Status</h5>
    <p>Are you sure you want to update the status?</p>
  </ModalBody>
  <ModalFooter>
    <Button color="secondary" onClick={() => setStatusModal(false)}>Cancel</Button>
    <Button color="primary" onClick={handleChangeStatus}>Change Status</Button>
  </ModalFooter>
</Modal>

    </React.Fragment>
  );
};

export default withTranslation()(CompanyManagement);